import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/about.css';
import '../assets/css/services.css';
import '../assets/css/services-offered.css';

export default function Services() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    return (
        <>
            {/* Professional Banner Section */}
            <section className="vas-activity-banner">
                <div className="vas-banner-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="vas-banner-content">
                                <div className="vas-breadcrumb mb-3">
                                    <Link to="/" className="breadcrumb-link">Home</Link>
                                    <span className="breadcrumb-separator">›</span>
                                    <span className="breadcrumb-current">Services</span>
                                </div>
                                <h1 className="vas-banner-title">Our Services</h1>
                                <p className="vas-banner-subtitle">
                                    Comprehensive logistics and warehousing solutions for your business
                                </p>
                                <div className="vas-banner-divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Grid Section */}
            <section className="services-section py-5">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8 mx-auto text-center">
                            <h2 className="section-title mb-3">Key Services Offered</h2>
                            <p className="section-subtitle text-muted">
                                We provide end-to-end logistics solutions designed to streamline your supply chain and enhance operational efficiency
                            </p>
                        </div>
                    </div>

                    {/* Services Cards Grid */}
                    <div className="row g-4">
                        {/* Service 1 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-warehouse"></i>
                                </div>
                                <h3 className="service-card-title">Warehousing Service</h3>
                                <p className="service-card-description">
                                    Wide temperature range storage solutions including frozen, chilled, cool and dry storage facilities to meet all your warehousing needs.
                                </p>
                            </div>
                        </div>

                        {/* Service 2 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-boxes"></i>
                                </div>
                                <h3 className="service-card-title">Food Handling & Inventory Management</h3>
                                <p className="service-card-description">
                                    Professional food handling services with comprehensive inventory management systems to ensure product quality and accurate stock control.
                                </p>
                            </div>
                        </div>

                        {/* Service 3 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-file-contract"></i>
                                </div>
                                <h3 className="service-card-title">Customs Clearance Formalities</h3>
                                <p className="service-card-description">
                                    Hassle-free customs clearance services to expedite your import/export processes with complete documentation support.
                                </p>
                            </div>
                        </div>

                        {/* Service 4 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-plus-circle"></i>
                                </div>
                                <h3 className="service-card-title">Value Added Services</h3>
                                <p className="service-card-description">
                                    Comprehensive value-added services to enhance your product offerings and streamline your supply chain operations.
                                </p>
                            </div>
                        </div>

                        {/* Service 5 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-box-open"></i>
                                </div>
                                <h3 className="service-card-title">Promotional Packaging Services</h3>
                                <p className="service-card-description">
                                    Professional packaging solutions for promotional campaigns to enhance your brand visibility and market presence.
                                </p>
                            </div>
                        </div>

                        {/* Service 6 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-barcode"></i>
                                </div>
                                <h3 className="service-card-title">Dubai Municipality Product/Barcode Registration</h3>
                                <p className="service-card-description">
                                    Complete assistance with Dubai Municipality product and barcode registration for seamless market entry.
                                </p>
                            </div>
                        </div>

                        {/* Service 7 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-check-circle"></i>
                                </div>
                                <h3 className="service-card-title">Dubai Municipality Inspection & Clearance</h3>
                                <p className="service-card-description">
                                    Expert handling of Dubai Municipality inspection processes and clearance procedures to ensure compliance.
                                </p>
                            </div>
                        </div>

                        {/* Service 8 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-chart-line"></i>
                                </div>
                                <h3 className="service-card-title">Real-time Data Access</h3>
                                <p className="service-card-description">
                                    24/7 real-time access to your inventory data and shipment information for complete visibility and control.
                                </p>
                            </div>
                        </div>

                        {/* Service 9 */}
                        <div className="col-lg-6 col-md-6">
                            <div className="service-card">
                                <div className="service-card-icon">
                                    <i className="fas fa-truck"></i>
                                </div>
                                <h3 className="service-card-title">Transportation</h3>
                                <p className="service-card-description">
                                    Reliable transportation services with a modern fleet to ensure timely and safe delivery of your goods.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Services Offered Section - Professional Circular Design */}
            <section className="services-offered-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-12 text-center">
                            <h2 className="services-offered-title">SERVICES OFFERED</h2>
                        </div>
                    </div>

                    <div className="row g-5">
                        {/* Service 1 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-1.png')} alt="Pick-up from Origin" />
                                </div>
                                <h4 className="service-offered-name">Pick-up from Origin</h4>
                            </div>
                        </div>

                        {/* Service 2 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-2.png')} alt="Air / Sea / Land Freight" />
                                </div>
                                <h4 className="service-offered-name">Air / Sea / Land Freight</h4>
                            </div>
                        </div>

                        {/* Service 3 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-3.png')} alt="Customs Clearance" />
                                </div>
                                <h4 className="service-offered-name">Customs Clearance</h4>
                            </div>
                        </div>

                        {/* Service 4 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-4.png')} alt="VAS Services" />
                                </div>
                                <h4 className="service-offered-name">VAS Services</h4>
                            </div>
                        </div>

                        {/* Service 5 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-5.png')} alt="Inventory Management" />
                                </div>
                                <h4 className="service-offered-name">Inventory Management</h4>
                            </div>
                        </div>

                        {/* Service 6 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-6.png')} alt="Municipality Clearance" />
                                </div>
                                <h4 className="service-offered-name">Municipality Clearance</h4>
                            </div>
                        </div>

                        {/* Service 7 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-7.png')} alt="Warehousing" />
                                </div>
                                <h4 className="service-offered-name">Warehousing</h4>
                            </div>
                        </div>

                        {/* Service 8 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-8.png')} alt="Pick and Pack" />
                                </div>
                                <h4 className="service-offered-name">Pick and Pack</h4>
                            </div>
                        </div>

                        {/* Service 9 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-9.png')} alt="Dispatch of Goods" />
                                </div>
                                <h4 className="service-offered-name">Dispatch of Goods</h4>
                            </div>
                        </div>

                        {/* Service 10 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-10.png')} alt="Transportation Services" />
                                </div>
                                <h4 className="service-offered-name">Transportation Services</h4>
                            </div>
                        </div>

                        {/* Service 11 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-11.png')} alt="Delivery to Stores or Distribution Centre" />
                                </div>
                                <h4 className="service-offered-name">Delivery to Stores or Distribution Centre</h4>
                            </div>
                        </div>

                        {/* Service 12 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="service-offered-item">
                                <div className="service-offered-icon">
                                    <img src={require('../assets/images/icons/icons-12.png')} alt="Cello Wrapping" />
                                </div>
                                <h4 className="service-offered-name">Cello Wrapping</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action Section */}
            <section className="cta-section py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <h2 className="cta-title mb-3">Ready to Optimize Your Supply Chain?</h2>
                            <p className="cta-text mb-4">
                                Get in touch with our team to discuss how we can help streamline your logistics operations
                            </p>
                            <Link to="/contact" className="btn btn-primary btn-lg">
                                Contact Us Today
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
